import styled from 'styled-components';
import { IconButton } from '@material-ui/core';
import theme from './defaultTheme';

export const Content = styled.div`
    flex: 1;
    height: 100%;
    overflow: auto;
    background-color: ${(props) => props.theme.lightGrey};

    @media(min-width: 621px) {

      position: absolute;
      width: calc(100% - 248px);
      left: 248px;
    }
`;

export const Main = styled.div`
  display: flex;
  margin:0;
  padding: 0;
  height: 100vh;
  width: 100%;
  background-color: ${(props) => props.theme.backgroundTransparent};
`;

export const RoutesContent = styled.div`
    min-height: calc(100vh - 308px);
`;

export const PageTitle = styled.div`
  text-align: left;
  font: ${theme.font.body[4]};
  letter-spacing: 0px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
`;

export const Container = styled.div`
  background-color: transparent;
  width: 100%;
  max-width: 864px;
  margin: 0 auto 20px auto;
`;

// Container usado dentro das paginas de fluxos
export const PageContainer = styled.div`
    padding: 32px 122px;

    @media screen and (max-width: 950px) {
        padding: 24px 16px;
    }
`;

export const PageContainerSmall = styled.div`
    padding: ${theme.padding.x4};

    @media screen and (max-width: 950px) {
        padding: 24px 16px;
    }
`;

export const TableContainer = styled.div`
    padding: ${theme.margin.x4}
`;

export const ContainerButton = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    gap: 24px;

    @media screen and (max-width: 950px) {
        flex-direction: column;
        gap: 0;
    }
`;

export const ButtonSection = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const ContainerDataTable = styled.div`
    padding: 0 32px;
`;

export const TableContent = styled.div`
    display: flex;
    justify-content: center;
`;

export const CustomIconButton = styled(IconButton)`
    &.MuiButtonBase-root {
        pointer-events: none;
        position: absolute;
        transition: 0.5s;
        right: 0;
        top: 50%;
        transform: translateY(-50%) rotate(${({ isOnFocus }) => (isOnFocus ? '180' : '0')}deg);
        margin: 0 8px;
        padding: 8px;
    }
`;
